import React from 'react';
import Routes from './routes';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'App/components/errors';
import { ThemeProvider } from '@emotion/react';
import styleVars from './sass/base/_vars.scss';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { isProd } from './app/components/config/config';
import { queryClient } from 'Shared/queryClient';
import { Toaster } from 'Shared/toast';

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={styleVars}>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <Routes />
                </ErrorBoundary>
                <Toaster />
            </ThemeProvider>
            {isProd ? null : <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />}
        </QueryClientProvider>
    );
}

export default App;
